import { createContext } from 'react';

const AthsContext = createContext();

export const AthsProvider = AthsContext.Provider;
export default AthsContext;
